import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

export const MainContainer = styled(Box)(`
  display: flex;
  height: 100vh;

  &.fullScreen {
    .desktopMenu { margin-top: -56px; }
    .contentSection { height: 100vh; }
    .contentSection > div:nth-of-type(1) { margin-left: -220px; }
    .contentSection > div:nth-of-type(2) { max-width: 100%; }

    /* .insightsOuterWrapper { transform: translateX(300px); } */
    /* .hideRhsInsights { overflow: hidden; } */
    /* .reportOuterWrapper { max-width: 100% !important; } */
    
    /* .reportOuterWrapper { max-width: 100% !important; } */
    /* .moveInsightsToRight .reportOuterWrapper { max-width: 100%; }
    .moveInsightsToRight .insightsOuterWrapper { 
      position: absolute;
      background: #fff;
      top: 75px;
      right: 20px;
    } */
  }

  &.fullScreen.showLhsMenu {
    .contentSection > div:nth-of-type(1) {
      position: absolute;
      left: 276px;
      /* z-index: 2; */
      height: 100vh;
      box-shadow: -5px 0 20px 0px rgba(0, 0, 0, 0.4);
    }
  }
  
  &.md-screen {
    .contentSection > div:nth-of-type(1) { margin-left: -220px; }
    .contentSection > div:nth-of-type(2) { max-width: 100%; }
    .report-brand-imaginary-th { min-width: 120px; }
  }

  &.md-screen.showLhsMenu {
    .contentSection > div:nth-of-type(1) {
      position: absolute;
      left: 276px;
      box-shadow: -5px 10px 20px 0px rgba(0, 0, 0, 0.4);
    }
  }

  &.sm-screen #reportsContentSection  {
    .contentSection > div:nth-of-type(1) {
      width : 200px;
    }

    .report-brand-imaginary-th { min-width: 100px; }


    .pageRoot .insightsOuterWrapper {
      max-width : 200px !important;  
    }

    .pageRoot .reportOuterWrapper {
      max-width: calc(100% - 200px) !important;
    }
  }

`)

export const RightSideContainer = styled(Box)(`
  display: flex;
  flex-direction: column;
  flex: 1;
`)

export const HeroSection = styled(Box)(`
  height: 100vh;
  display: flex;
  height: calc(100vh - 56px);
  transition: all 0.5s; // FullScreening
  justify-content: end;
`)

export const MiddleContainer = styled(Box)(`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden; 
  transition: all 1.0s; // FullScreening
  max-width: calc(100% - 220px);
`)

export const NavigationBarContainer = styled(Box)(`
  display: flex;
  align-items: center;
  height: 56px ;
  border-bottom: 1px solid #D8D8D6;
  padding: 0px 20px;
  width: auto;

  & .hamburderMenu {
    margin:0 10px 0 -5px;
  }
`)

export const IconWrapper = styled(Box)(`
  display: flex;
  align-items: center;
  margin: 0 8px;

  svg {
    font-size: 12px;
  }
`)

export const BoldText = styled(Typography)(`
  font-weight: 600; // 500;
  font-size: 19px;
  line-height: 24px;
  text-wrap-mode: nowrap;
`)

export const OptionTitle = styled(Typography)(`
  line-height: 24px;
  color: #686867;
  font-weight: 400;
  font-size: 19px;
  margin-left: 8px;
  padding-left: 22px;
  position: relative;
  width:100%;

  &:empty {
    visibility: hidden;
  }

  &:before {
    content: '';
    display: block;
    transform: rotate(45deg);
    width: 10px;
    height: 10px;
    border-right: 1px #000 solid;
    border-top: 1px #000 solid;
    position: absolute;
    top: 7px;
    left: 0;
  }
`)

export const ContentSection = styled(Box)(`
  flex: 1;
  display: flex;
  flex-direction: column;  
  scroll-behavior: smooth;
  /* overflow-y:auto; */
`)

export const Container = styled(Box)(`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  &.componentIsLoading {
    
    & .loadingWrapper {
      visibility: hidden;
    }
    & .reportPageLoader {
      display:flex;
    }
    & .reportPageLoader .loadingWrapper {
      visibility: visible;
    }
  }

  &.tourGuideActive {
    overflow-x : hidden;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.5);
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.5); /* Same as overlay */
      border-radius: 4px;
      border: 1px solid transparent;
    }
  }

`)

// export const TabOuterWrapper = styled(Box)(`
//   padding: 16px 20px;
//   position: relative;
//   top: 0;
//   background: #fff;
//   z-index: 11;
//   transition: all 0.3s ease;
//   box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);

//   &:empty {display:none;}

//   & h4 {display:none;}

//   display:none !important;
// `)
